export default __webpack_public_path__ + "static/media/photo5.90a7be62.jpg";